import { motion } from "framer-motion";
import { Building2, Home, PackageOpen, Check, ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/site";

const ICONS = {
  commercial: Building2,
  "move-in": Home,
  "move-out": PackageOpen,
};

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 bg-slate-50 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#2563eb]">
            Services Provided
          </span>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight text-[#0f2452]">
            Tailored cleaning for every space
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Customized residential and commercial solutions designed to keep
            your home or business clean, healthy and professional.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-3 gap-7">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[s.id];
            return (
              <motion.div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: idx * 0.08 }}
                className="group flex flex-col rounded-3xl border border-slate-200 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:border-[#2563eb]/40"
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#0f2452] text-white group-hover:bg-[#2563eb] transition-colors">
                  <Icon className="h-7 w-7" />
                </div>
                <h3 className="font-display mt-6 text-xl font-bold text-[#0f2452]">
                  {s.title}
                </h3>
                <p className="mt-1 text-sm font-medium text-[#2563eb]">
                  {s.tagline}
                </p>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {s.blurb}
                </p>

                <ul className="mt-5 space-y-2.5 flex-1">
                  {s.features.map((f) => (
                    <li
                      key={f}
                      className="flex items-start gap-2.5 text-[14px] text-slate-700"
                    >
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#2563eb]" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-6 pt-5 border-t border-slate-100">
                  <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
                    Ideal for
                  </p>
                  <div className="mt-2 flex flex-wrap gap-2">
                    {s.idealFor.map((t) => (
                      <span
                        key={t}
                        className="rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-600"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>

                <a
                  href="#quote"
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#2563eb] hover:gap-2.5 transition-all"
                >
                  Get a quote for this <ArrowRight className="h-4 w-4" />
                </a>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
